import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ShIconModule, ShProfileConfigService } from '@stylehaven/components';
import { ReadableDatePipeModule } from '../pipes/readable-date-pipe';
import { DocumentPublicityReadonlyFieldComponent } from './components/readonly/document-publicity-readonly-field/document-publicity-readonly-field.component';
import { DossierPublicityReadonlyFieldComponent } from './components/readonly/dossier-publicity-readonly-field/dossier-publicity-readonly-field.component';
import { RecordReuseReadonlyFieldComponent } from './components/readonly/record-reuse-readonly-field/record-reuse-readonly-field.component';
import { RetentionPeriodReadonlyFieldComponent } from './components/readonly/retention-period-readonly-field/retention-period-readonly-field.component';
import { SeriesProcessReadonlyFieldComponent } from './components/readonly/series-process-readonly-field/series-process-readonly-field.component';
import { SeriesServiceReadonlyFieldComponent } from './components/readonly/series-service-readonly-field/series-service-readonly-field.component';
import { ProfileConfigService } from './services/profile-config.service';

@NgModule({
    declarations: [
        RetentionPeriodReadonlyFieldComponent,
        SeriesProcessReadonlyFieldComponent,
        RecordReuseReadonlyFieldComponent,
        DocumentPublicityReadonlyFieldComponent,
        DossierPublicityReadonlyFieldComponent,
        SeriesServiceReadonlyFieldComponent
    ],
    imports: [CommonModule, ShIconModule, ReadableDatePipeModule],
    providers: [
        {
            provide: ShProfileConfigService,
            useClass: ProfileConfigService
        }
    ],
    exports: [RetentionPeriodReadonlyFieldComponent]
})
export class DigihavenRecordProfilesFormModule {}
